import React from 'react';

import { Icon } from 'js/design_system/Icon';
import { ImpressionWatcher } from 'js/utils/impressions/ImpressionWatcher';
import trackClick from 'js/utils/trackClick';

import { IconAnchor, IconContainer, IconLabel } from './buttonStyles';

export const LIBRARY_NAV_CLICK_SOURCE = 'nav-bar--library';
export const LIBRARY_NAV_IMPRESSION_SOURCE = 'academia_library.nav';

type LibraryButtonProps = {
  /**
   * Server-built (FocusedNavPresenter#library_href): the web workspace for a
   * reader who has signed in to the Academia Library desktop app, the download
   * page for everyone else.
   */
  href: string;
};

/**
 * The classic nav's Library item, in the slot the Grants item used to fill.
 */
const LibraryButton = ({ href }: LibraryButtonProps) => (
  <ImpressionWatcher key="library" source={LIBRARY_NAV_IMPRESSION_SOURCE}>
    <IconAnchor
      href={href}
      onClick={() => trackClick({ source: LIBRARY_NAV_CLICK_SOURCE })}
    >
      <IconContainer>
        <Icon name="account_balance" size={24} />
      </IconContainer>
      <IconLabel>Library</IconLabel>
    </IconAnchor>
  </ImpressionWatcher>
);

export default LibraryButton;
